export default function CapabilityMatrix({ items, exhibitions }) {
  return (
    <div className="capabilities" data-section="strengths">
      <div className="capabilities__grid">
        {items.map((item) => (
          <article key={item.number}>
            <span>{item.number}</span>
            <h3>{item.name}</h3>
            <p>{item.description}</p>
          </article>
        ))}
      </div>
      <div className="exhibitions">
        <span className="exhibitions__label">Selected fictional exhibitions</span>
        {exhibitions.map((item) => (
          <div key={`${item.year}-${item.title}`}>
            <time>{item.year}</time>
            <strong>{item.title}</strong>
            <span>{item.detail}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
